/**
 * @deprecated
 */
"use strict";

import lottie from 'lottie-web';

import { createApp } from 'vue'

import ImportApp from './components/ImportApp'

import PerfectScrollbar from 'vue3-perfect-scrollbar'
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css'

import CheckOption from './import/check-option'
import EntryRow from "./import/entry-row";
import DateOption from './import/date-option';
import InputOption from './import/input-option';

if(document.getElementById('importApp')){
    const app = createApp(ImportApp);
    app.use(PerfectScrollbar);
    app.use(CheckOption);
    app.use(EntryRow);
    app.use(DateOption);
    app.use(InputOption);

    app.config.compilerOptions.delimiters = ['{[{', '}]}'];
    const vm = app.mount('#importApp');

    window['importApp'] = vm;

    require( './import/_dropdown-hack' )
}
if(document.getElementById('importApp2')){
   // Vue.options.delimiters = ['{[{', '}]}'];

    /*Vue.use(PerfectScrollbar, {
        options: {
            suppressScrollY: true,
            useBothWheelAxes: true,
            wheelSpeed: 2,
        }
    });*/

    const importApp = createApp({
        //el: '#importApp',
        components: {
            CheckOption,
            EntryRow,
            DateOption,
            InputOption,
        },
        data: {
            isFormEnabled: true,
            isAutoDetected: false,
            isUploaded: false,
            isPreparingPreview: false,
            exampleActiveIndex: 0,
            entry: { // Currently processed xlsx
                processed: 0,
                total: 0,
                columns: [],
                examples: [],
                is_update_existing: false,
                import_file: {
                    file_name: ""
                }
            },
            columnsBinding: {},
            columnsOptions: {},
            importedExample: {
                first_name: "",
                last_name: "",
                email: "",
                phone: "",
                address: "",
                city: "",
                country: "",
                connection: "",
                notes: "",
                description: "",
                language: "",
                sex: "",
                birth: "",
                donations: []
            },
            defaultEntry: {
                processed: 0,
                total: 0,
                columns: [],
                examples: [],
                is_update_existing: false,
                import_file: {
                    file_name: ""
                }
            },
            fields: {},
            labels: {},
            rocket: null,
            rocketCollapsedState: false,
            rocketStarted: false,
            rocketFrame: 30,
        },
        methods: {
            startImport(){
                $(this.$refs.importStartBtn).prop('disabled', true).toggleClass('oc-loading', true);

                $.request('importContacts::onImportStart', {
                    flash: 1,
                    data: {
                        id: importApp.entry.id
                    },
                    error(xhr,b,c){
                        if(xhr.responseJSON && xhr.responseJSON.X_OCTOBER_ERROR_MESSAGE){
                            $.oc.flashMsg({
                                class: "error",
                                text: xhr.responseJSON.X_OCTOBER_ERROR_MESSAGE
                            })
                        }
                    },
                    success(xhr, text) {
                        if(xhr.responseJSON
                            && xhr.responseJSON.X_OCTOBER_FLASH_MESSAGES
                            && xhr.responseJSON.X_OCTOBER_FLASH_MESSAGES.success){
                            $.oc.flashMsg({
                                class: "success",
                                text: xhr.responseJSON.X_OCTOBER_FLASH_MESSAGES.success
                            })
                        }

                        importApp.isUploaded = false;
                        importApp.isFormEnabled = false;
                        importApp.isAutoDetected = false;
                        importApp.entry = importApp.defaultEntry;

                        importApp.columnsBinding = {};
                        importApp.columnsOptions = {};

                        importApp.rocketLaunch();
                    },
                    complete(){

                        $(importApp.$refs.importStartBtn).prop('disabled', false).toggleClass('oc-loading', false);
                    }
                });
            },
            detectBindingByNames() {
                this.entry.columns.forEach( (columnName, columnIndex) => {
                    if (typeof this.fields[columnName] !== 'undefined') {
                        this.columnBind(columnIndex, columnName, true);
                    }
                    if (typeof this.fields[`virtual_${columnName}`] !== 'undefined') {
                        this.columnBind(columnIndex, `virtual_${columnName}`, true);
                    }
                });
                this.sendBindings();
                this.isAutoDetected = true;
            },
            afterOptionChanged(value, columnIndex) {

                //  this.columnsOptions[columnIndex] = value;

                this.sendBindings();
            },
            sendBindings() {
                $.request('importContacts::onBindColumns', {
                    data: {
                        binding: this.columnsBinding,
                        options: this.columnsOptions
                    },
                    success() {
                        importApp.preparePreview();
                    }
                });
            },
            getDefaultOptionValue(option) {
                switch (option) {
                    case "add_date":
                        return "01-01-2020";
                    default:
                        return "false";
                }
            },
            columnBind(columnIndex, field, stopSending = false) {
                this.isAutoDetected = false;
                this.columnsBinding[columnIndex] = field;

                let existsOptions = (this.columnsOptions[columnIndex]) ? this.columnsOptions[columnIndex] : {};

                let fieldAvailableOptions = this.fields[field];
                if (typeof fieldAvailableOptions !== 'undefined') {
                    this.fields[field].forEach(function (option) {
                        if (typeof existsOptions[option] === 'undefined') {
                            existsOptions[option] = importApp.getDefaultOptionValue(option);
                        }
                    });
                }

                this.columnsOptions[columnIndex] = existsOptions;

                if (!stopSending) {
                    $(`#dropdownMenuButton${columnIndex}`).dropdown('hide')
                    this.sendBindings();
                }
            },
            columnUnbind(columnIndex) {
                this.isAutoDetected = false;
                if (this.columnsBinding[columnIndex]) {
                    Vue.delete(this.columnsBinding, columnIndex)
                }
                if (this.columnsOptions[columnIndex]) {
                    Vue.delete(this.columnsOptions, columnIndex)
                }

                this.sendBindings();
            },
            loadImportEntry() {
                $.request('importContacts::onLoadEntry', {
                    success(data) {
                        importApp.fileUploadedCallback(data)
                    }
                });
            },
            deleteCurrentImport() {
                if(! confirm("Import will be cancelled and current column binding will lost. Continue?")){
                    return;
                }
                this.isUploaded = false;
                this.isAutoDetected = false;
                $.request('importContacts::onDeleteCurrentImport', {
                    success(data) {
                        importApp.entry = importApp.defaultEntry;

                        importApp.columnsBinding = {};
                        importApp.columnsOptions = {};
                    }
                });
            },
            filesChange(name, files) {
                // document.querySelector('#importFileForm').dispatchEvent('submit');

                $(this.$refs.importForm).trigger('submit');

                if (files.length > 0) {
                    const file = files[0];


                }
            },
            fileUploadedCallback(data) {
                if (typeof data['_entry'] !== 'undefined' && data['_entry']) {
                    importApp.isUploaded = true;
                    importApp.entry = data['_entry'];

                    importApp.preparePreview();
                }
                if (typeof data['_fields'] !== 'undefined') {
                    importApp.fields = data['_fields'];
                }
                if (typeof data['_labels'] !== 'undefined') {
                    importApp.labels = data['_labels'];
                }
                if (typeof data['_binding'] !== 'undefined') {
                    importApp.columnsBinding = {};
                    importApp.columnsOptions = {};

                    for (let columnIndex in data['_binding']) {
                        importApp.columnsBinding[columnIndex] = data['_binding'][columnIndex].field;
                        importApp.columnsOptions[columnIndex] = data['_binding'][columnIndex].options;
                    }

                }
            },
            preparePreview() {
                this.isPreparingPreview = true;
                $.request('importContacts::onPrepareImportPreview', {
                    data: {
                        exampleIndex: importApp.exampleActiveIndex,
                        binding: importApp.columnsBinding,
                        options: importApp.columnsOptions
                    },
                    success(data) {
                        if (typeof data['_preview'] !== 'undefined') {
                            importApp.importedExample = data['_preview']
                        }
                    },
                    complete() {
                        importApp.isPreparingPreview = false;
                    }
                });
            },
            initTable(){
                let $this = $('.table-dashboard');
                let options = $.extend({
                    responsive: false,
                }, $this.data('options'));
                $this.dataTable(options);
            },
            rocketCollapse(){
                let fromFrame = this.rocketFrame;
                this.rocket.playSegments([fromFrame,20], true);
                this.rocketCollapsedState = true;
                this.rocketFrame = 20;
            },
            rocketExpand(){
                let fromFrame = this.rocketFrame;
                this.rocket.playSegments([fromFrame,30], true);
                this.rocketCollapsedState = false;
                this.rocketFrame = 30;
            },
            rocketLaunch(){
                let fromFrame = this.rocketFrame;
                this.rocket.playSegments([fromFrame,180], true);
                this.rocketFrame = 180;
                this.rocketCollapsedState = false;
                this.rocketStarted = true;
            },
            rocketToggle(){
                if(this.rocketCollapsedState === true){
                    this.rocketExpand();
                } else {
                    this.rocketCollapse();
                }
            },
            saveImportEntry(){
                if(typeof importApp.entry.id === 'undefined') return;

                $.request('importContacts::onImportSave', {
                    flash: 1,
                    data: {
                        id: importApp.entry.id,
                        entry: {
                            is_update_existing: importApp.entry.is_update_existing
                        }
                    },
                });
            },
            exampleToggleIndex(activeIndexNew){
                this.exampleActiveIndex = activeIndexNew;
                this.preparePreview();
            }
        },
        watch: {
            entryIsUpdateExisting: function(){
                this.saveImportEntry()
            },
            columnsOptions: {
                deep: true,
                handler: function (newV, oldV) {
                    //console.log(newV, oldV)
                }
            }
        },
        computed: {
            entryIsUpdateExisting: function(){
                return this.entry.is_update_existing;
            },
            runningHelpShow: function () {
                return ! (! this.isUploaded && ! this.isFormEnabled)
            }
        },
        mounted: function () {
            // autorun
            this.loadImportEntry();

            this.rocket = lottie.loadAnimation({
                container: document.getElementById('rocket'), // the dom element that will contain the animation
                renderer: 'svg',
                loop: false,
                autoplay: false,
                path: '/themes/contacts/assets/img/rocket.json', // the path to the animation json
                rendererSettings: {
                    preserveAspectRatio: 'xMidYMid slice', // xMidYMid meet
                }
            });
            this.rocket.setSpeed(.75);
            this.rocket.goToAndStop(30, true);

            this.initTable();
        },
    });
    importApp.config.compilerOptions.delimiters = ['{[{', '}]}'];
    importApp.component('perfect-scrollbar', PerfectScrollbar);
    importApp.mount('#importApp');

    window['importApp'] = importApp;

    require ( './import/_dropdown-hack' )


}

